export default class TableFilter {
    constructor(view) {
        this.view = view;
        this.buttons = this.view.querySelectorAll(".filterBtn");
        this.tables = this.view.querySelector(".tables");
        this.filter = this.view.querySelector(".filters");
        this.mobileFilters = this.filter.querySelector(".mobile");
        this.desktopFilters = this.filter.querySelector(".desktop");

        this.initListeners(this.tables, this.buttons, this.filter);
        this.initMobile(this.mobileFilters, this.tables, this.desktopFilters);
    }


    initListeners(tables, buttons, filter){
        for(var i = 0; i < buttons.length; i++){
            buttons[i].addEventListener("click", function(e){
                var btnId = e.target.id;
                var tableId = "#" + btnId + "-table";
                var table = tables.querySelector(tableId);
                var currentActiveTable = tables.querySelector(".active");
                var currentActiveButton = filter.querySelector(".active");


                if(!table.classList.contains("active" && currentActiveTable != table)){
                    //remove current active classlist
                    currentActiveTable.classList.remove("active");
                    currentActiveButton.classList.remove("active");

                    table.classList.add("active");
                    e.target.classList.add("active"); //set button to active

                    //sync with mobile
                    var mobileFilter = filter.querySelector(".mobile");
                    var activeMobileFilter = mobileFilter.querySelector(".btn-active");
                    var dropdownBtnContent = mobileFilter.querySelector(".dropdown-btn > .content");
                    var newActiveFilter = mobileFilter.querySelector("#" + btnId);
                    activeMobileFilter.classList.remove("btn-active");
                    newActiveFilter.classList.add("btn-active");
                    dropdownBtnContent.innerHTML = newActiveFilter.innerHTML;
                }
            });
        }
    }

    initMobile(mobileFilters, tables, desktopFilter){
        var dropdownBtn = mobileFilters.querySelector(".dropdown-btn");
        var dropdownContent = mobileFilters.querySelector(".dropdown-content");
        var dropdownContentButtons = dropdownContent.querySelectorAll("button");
        console.log(dropdownContentButtons);

        dropdownBtn.addEventListener("click", function(e){
            e.stopPropagation();
            var elem = (e.currentTarget);
            var activeClass = "dropdown-btn-active";
            var content = mobileFilters.querySelector(".dropdown-content");
            var svgElem = elem.querySelector("svg");
            //toggle dropdown
            if(elem.classList.contains(activeClass)){ 
                //close
                elem.classList.remove(activeClass);
                content.classList.remove("dropdown-content-active");
                svgElem.classList.add("svg-closed");
                svgElem.classList.remove("svg-open");
            }else{ 
                //open
                elem.classList.add(activeClass);
                content.classList.add("dropdown-content-active");
                svgElem.classList.remove("svg-closed");
                svgElem.classList.add("svg-open");
            }
        });

        for(var i = 0; i < dropdownContentButtons.length; i++){
            //select filtered table
            dropdownContentButtons[i].addEventListener("click", function(e){
                e.stopPropagation();
                var clickedBtn = (e.currentTarget);
                var tableId = clickedBtn.id + "-table";
                var activeBtnClass = "btn-active";
                var activeTableClass = "active"
                var currentActiveButton = mobileFilters.querySelector("." + activeBtnClass);
                var currentActiveTable = tables.querySelector("." + activeTableClass);
              
                if(clickedBtn != currentActiveButton){
                    clickedBtn.classList.add(activeBtnClass);
                    currentActiveButton.classList.remove(activeBtnClass);
                    currentActiveTable.classList.remove(activeTableClass);
                    var newActiveTable = tables.querySelector("#" + tableId);
                    if(newActiveTable){
                        newActiveTable.classList.add(activeTableClass);
                        
                        var dropdownBtn = mobileFilters.querySelector(".dropdown-btn");
                        var dropdownBtnContent = dropdownBtn.querySelector(".content");
                        var dropdownContent = mobileFilters.querySelector(".dropdown-content");
                        var svgElem = dropdownBtn.querySelector("svg");

                        dropdownBtnContent.innerHTML = clickedBtn.innerHTML;//change dropdown btn value

                        //toggle dropdown
                        dropdownBtn.classList.remove("dropdown-btn-active");
                        dropdownContent.classList.remove("dropdown-content-active");
                        svgElem.classList.add("svg-closed");
                        svgElem.classList.remove("svg-open");

                        //sync with desktop version
                        var desktopActiveBtn = desktopFilter.querySelector(".active");
                        var newDesktopActiveBtn = desktopFilter.querySelector("#" + clickedBtn.id);
                        desktopActiveBtn.classList.remove("active");
                        newDesktopActiveBtn.classList.add("active");
                    }
                        

                    
                }
            })
        }


    }
    

}